import { BookingTypeValues } from '@components/BookingType';

export const roomsFilters: Record<string, { [key: string]: Boolean }> = {
  [BookingTypeValues.OnlySpaces]: { hasPublicMeetingRooms: true },
  [BookingTypeValues.OnlyAccommodations]: { hasPublicGuestRooms: true },
  [BookingTypeValues.AccommodationAndSpaces]: {
    hasPublicMeetingRooms: true,
    hasPublicGuestRooms: true,
  },
};
